import styled, { css } from 'styled-components/macro';

export const Container = styled.div<{ disabled?: boolean }>`
  ${({ theme }) => css`
    box-sizing: border-box;
    padding-block: ${theme.spacings.componentOnly};
    padding-inline: ${theme.spacings.s};
    display: inline-flex;
    align-items: center;
    border: 1px solid ${theme.colors.gray[300]};
    border-radius: ${theme.radiuses.xs};
    background: ${theme.colors.white};
    overflow: hidden;
    transition: all 0.2s ease;

    &:focus-within {
      border-color: ${theme.colors.primary[500]};
    }

    input {
      padding: 0;
      border: none !important;
      outline: none !important;
      width: 100%;
      text-align: center;

      &:focus {
        box-shadow: none !important;
      }
    }

    /* Убираем стрелки у number input */
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }

    input[type='number'] {
      -moz-appearance: textfield;
    }
  `}
`;

export const StepperButton = styled.button`
  ${({ theme }) => css`
    padding: 0;
    margin: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    color: ${theme.colors.gray[400]};
    background-color: transparent;
    cursor: pointer;
    transition-duration: ${theme.tokens.animation.duration.base};

    &:hover:not(:disabled) {
      color: ${theme.colors.gray[600]};
    }

    &:disabled {
      cursor: not-allowed;
    }
  `};
`;
